import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomButton, CustomLoadingButton } from "src/design";
import {
  colorActionPrimary,
  colorActionPrimaryHover,
  colorActionPrimaryText,
  colorTextMuted,
  colorTextPrimary,
  radiusButton,
} from "src/design/tokens";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

type Props = {
  isEditing: boolean;
  updating: boolean;
  hasChanged: boolean;
  canEdit: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
};

export const GalleryHeader = ({
  isEditing,
  updating,
  hasChanged,
  canEdit,
  onEdit,
  onCancel,
  onSave,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        mb: 3,
      }}
    >
      <Box>
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, color: colorTextPrimary, mb: 0.5 }}
        >
          {t("gallery.title")}
        </Typography>
        <Typography variant="body2" sx={{ color: colorTextMuted }}>
          {t("gallery.subtitle")}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", gap: 1 }}>
        {isEditing ? (
          <>
            <CustomButton
              variant="outlined"
              color="inverted"
              size="small"
              onClick={onCancel}
              startIcon={<CloseOutlinedIcon />}
              sx={{ textTransform: "none", borderRadius: radiusButton, fontWeight: 500 }}
            >
              {t("common.cancel")}
            </CustomButton>
            <CustomLoadingButton
              startIcon={<SaveOutlinedIcon />}
              loading={updating}
              onSubmit={onSave}
              label={t("common.saveChanges")}
              disabled={!hasChanged}
              size="small"
              fullwidth={false}
              style={{ backgroundColor: "black", color: "white" }}
            />
          </>
        ) : canEdit ? (
          <CustomButton
            variant="contained"
            size="small"
            onClick={onEdit}
            sx={{
              textTransform: "none",
              borderRadius: radiusButton,
              fontWeight: 600,
              backgroundColor: colorActionPrimary,
              color: colorActionPrimaryText,
              "&:hover": { backgroundColor: colorActionPrimaryHover },
              boxShadow: "none",
            }}
          >
            {t("gallery.editGallery")}
          </CustomButton>
        ) : null}
      </Box>
    </Box>
  );
};
